import { useQuery } from 'react-query'
import { useLanguage } from 'src/core/components/LanguageProvider/hooks'
import apiKey from 'src/core/services/base/apiKey'
import { useUnAuthAlert } from 'src/shared/hooks/useUnAuthAlert'
import { getAccountPermission } from '.'

export default function useGetAccountPermission(hasLoginPermission = true) {
  const { language } = useLanguage()
  const { openUnAuthAlertMemoWithContent } = useUnAuthAlert()
  const FetchFunction = () => getAccountPermission(openUnAuthAlertMemoWithContent, language)
  const { data, isSuccess, isLoading } = useQuery([apiKey.getAccountPermission, language], FetchFunction, {
    retry: 3,
    enabled: hasLoginPermission,
  })

  return { data, isSuccess, isLoading }
}
